 if (window.jQuery) {
     var $ = window.jQuery;
 }
 document.addEventListener('DOMContentLoaded', function() {

    $("#video-player").remove();
    
    /**********************  on click review scroll at bottom start   ********************/ 
    document.addEventListener('click', function (e) {
        const el = e.target.closest('.product__block .pcard-reviews');

        if (el) {
            e.preventDefault();

            const target = document.getElementById('pr-reviewdisplay');
            const offset = 100;

            window.scrollTo({
                top: target.offsetTop - offset,
                behavior: 'smooth'
            });
        }
    });
   /**********************  on click review scroll at bottom end   ********************/ 
   
     /**** Code for showing product badges only on first asset starts ****/

     function addFirstMediaClass() {
         $(".thumbnail-list .product__thumbs-item").removeClass("first-media")
         $(".thumbnail-list .product__thumbs-item").each(function() {
             if ($(this).css("display") === "block") {
                 $(this).addClass("first-media");
                 return false; // Break out of .each()
             }
         });
     }
     document.addEventListener('variant:changed', function(event) {
         console.log("variant:changed----");
         addFirstMediaClass();

     });
     setTimeout(() => {
         addFirstMediaClass();
     }, 200);

     /**** Code for showing product badges only on first asset ends ****/

     /****** Code play video only if slide is visble in PDP starts ******/
     if (window.location.href.includes("/product")) {


         const players = new Map();

         // Load YouTube API if it's not already loaded
         if (!window.YT || !window.YT.Player) {
             const tag = document.createElement("script");
             tag.src = "https://www.youtube.com/iframe_api";
             document.head.appendChild(tag);
         }

         // Called automatically by the YouTube API
         window.onYouTubeIframeAPIReady = initYouTubePlayers;

         // If API is already loaded (e.g. Shopify section reload)
         if (window.YT && typeof window.YT.Player === "function") {
             initYouTubePlayers();
         }

         function initYouTubePlayers() {
             try {


                 const container = document.querySelector(".product__media-gallery-viewer");

                 if (!container) return;

                 document
                     .querySelectorAll(".product__media-item[data-is-video]")
                     .forEach((item) => {
                         const iframe = item.querySelector(".main-iframe-jt");

                         if (!iframe || players.has(iframe)) return;

                         const player = new YT.Player(iframe, {
                             events: {
                                 onReady: function() {
                                     console.log("Player ready");
                                 },
                             },
                         });

                         players.set(iframe, player);
                     });

                 observeVideos(container);
             } catch (error) {
                 console.log("err--", error);

             }
         }

         function observeVideos(container) {
             try {


                 const observer = new IntersectionObserver(
                     (entries) => {
                         entries.forEach((entry) => {
                             const iframe = entry.target.querySelector(".main-iframe-jt");
                             if(!iframe){
                               return;
                             }
                             const player = players.get(iframe);

                             if (!player) return;

                             if (entry.isIntersecting) {
                                 player.playVideo();
                                 console.log("▶ Play");
                             } else {
                                 player.pauseVideo();
                                 console.log("⏸ Pause");
                             }
                         });
                     }, {
                         root: container,
                         threshold: 0.5,
                     }
                 );

                 document
                     .querySelectorAll(".product__media-item[data-is-video]")
                     .forEach((item) => observer.observe(item));

             } catch (error) {
                 console.log("err--", error);

             }
         }
         const gallery = document.querySelector(".product__media-gallery-viewer");

         const mo = new MutationObserver(() => {
             console.log("Gallery changed");
             initYouTubePlayers();
         });

         mo.observe(gallery, {
             childList: true,
             subtree: true
         });
     }
     /****** Code play video only if slide is visble in PDP ends ******/

     $("a[href='#']").click((e) => {
         e.preventDefault();
     })
     setTimeout(() => {
         document.querySelectorAll('video img').forEach(img => {
             img.setAttribute('alt', 'Video preview image');
             img.setAttribute('aria-hidden', 'true');

         });
         document.querySelectorAll(
             'a.cbb-frequently-bought-product-image-link[data-href]'
         ).forEach(link => {
             if (!link.getAttribute('href')) {
                 link.setAttribute('href', link.dataset.href);
                 link.setAttribute('aria-label', "Frequent bought product");
             }
         });
     }, 100);

     const interval = setInterval(() => {
         const el = document.querySelector(".zinrelo-tab");
         if (el) {
             el.style.color = "white";
             el.style.background = "black";
             clearInterval(interval);
         }
     }, 100);




     //  {% comment %} PDP JS START {% endcomment %}




     if (jQuery("body").hasClass("template-product")) {
         var handleReview = setInterval(ReviewBlock, 500);

         function ReviewBlock() {
             if (jQuery(".pr-snippet-rating-decimal").length > 0) {
                 var url = jQuery(".pr-snippet-write-review-link").attr("href");
                 jQuery("#write-a-review .pr-snippet-review-count").attr("href", url);
                 var get_count = parseInt(jQuery(".pr-snippet-rating-decimal").text());
                 if (get_count > 0) {
                     jQuery("div#write-a-review").attr("style", "display:none");
                 } else {
                     jQuery("div#write-a-review").attr("style", "display:block");
                 }
                 clearInterval(handleReview);
             }

         }

     }


     jQuery(".swatch-selected-color.active").click(function() {
         jQuery('.try-on-original-selector').trigger('click');
     });

     jQuery(document).on("click", ".legend-grid-list-main button", function() {
         jQuery(".legend-grid-list-main button").removeClass("active")
         jQuery(this).addClass("active")
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("fieldset.list-style").removeClass('active')
             jQuery("fieldset.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("fieldset.list-style").addClass('active')
             jQuery("fieldset.grid-style").removeClass("active")
         }
     });


     jQuery(document).on("click", ".product-grid-list-toggle button", function() {
         jQuery(".product-grid-list-toggle button").removeClass("active")
         jQuery(this).addClass("active");
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("#products-container-list.list-style").removeClass('active')
             jQuery("#products-container-grid.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("#products-container-list.list-style").addClass('active')
             jQuery("#products-container-grid.grid-style").removeClass("active")
         }
     });

     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatch-color-selected', function() {
         // Remove 'active' class from all swatches
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');

         // Toggle 'active' only on the clicked element's sibling swatches
         jQuery(this).siblings("ul.swatches").toggleClass("active");
         jQuery(this).parents(".custom-selector").toggleClass("active");

     });

     jQuery(document).on('click', '.grid-style label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         var option_value_text = jQuery(this).prev("input[type='radio']").attr("value");
         console.log(option_value_text);
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".list-style .product-form__input").find("select").val(option_value_text);

         jQuery(".swatches--product-card li").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         })
     });


     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatches .swatch-value', function(e) {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         let v_id = jQuery(this).data("v-id");
         let style = jQuery(this).find("a.swatch-color").attr("style");
         let option_value = jQuery(this).find(".option-badge-wrapper").html()
         let option_value_text = $.trim(jQuery(this).find(".option-badge-wrapper .option-value").text());
         //console.log("option_value===",option_value)
         let targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
         let targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
         targetColor.attr("style", style);
         // console.log("targetValue====",targetValue)
         targetValue.html(option_value);
         if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
             targetValue.addClass("has-badge");
         } else {
             targetValue.removeClass("has-badge")
         }

         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")

         return false;
     });

     //For color categories of product page
     jQuery(document).on("click", ".color-category-grid li.color-swatch", function() {
         console.log("Click===");
         let option_value_text = $.trim(jQuery(this).data("color"));
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")
         jQuery(".color-category-grid li.color-swatch").removeClass("active")
         jQuery(this).addClass("active")
         console.log("Color=00--", option_value_text)
         jQuery(".swatches--product-card li.swatch-value").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 console.log(option + "==---==" + option_value_text)
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         });
     });

     $("sticky-atc-bar select[name='id']").change(function(e) {
         e.preventDefault();
         let option_value_text = $("sticky-atc-bar select[name='id'] option:selected").text().trim();
         let v_id = $("sticky-atc-bar select[name='id'] option:selected").val()
         if ($("#products-container-list").length) {
             $(`#products-container-list li[data-v-id='${v_id}']`).trigger("click")
         } else {
             jQuery(".product-form__input").find("select").val(option_value_text);
             document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
                 bubbles: true
             }));
             console.log("Sticky change 11 --")
         }
     })

     //keep this js in end otherwise rest will break

     if (jQuery("klarna-placement").length > 0) {

         var KlarnaIntervalId = setInterval(function() {
             var klarnaElement = document.querySelector('klarna-placement');
             try {

                 if (klarnaElement) {
                     var host = klarnaElement.shadowRoot.querySelector("div.default");
                     // alert('host'+ host);
                     if (host) {
                         var style = document.createElement("style");
                         style.innerHTML = ".container {border-radius: 4px; padding: 4px 6px; background:#fff; width: fit-content; } .container p { white-space: nowrap; font-weight: 400; font-size: 12px; } .container p .logo{ background: #ffb3c7; padding: 6px; border-radius: 4px; } .badge-container .badge {max-width: 36px;} .text-wrapper {margin-left: 6px;} .badge-container .badge svg {max-height: 15px;}  p, p .link{ font-size: 12px !important; color: #000; font-weight: 400;} .link{ text-decoration: none; margin-left: 4px;}";
                         host.appendChild(style);
                         clearInterval(KlarnaIntervalId);
                     } else {
                         // console.log('.top-strip-promotion-auto-size not found inside shadow DOM');
                         clearInterval(KlarnaIntervalId);
                     }
                 } else {
                     // console.log('klarna-placement element or Shadow DOM not found');
                     clearInterval(KlarnaIntervalId);
                 }
             } catch (error) {

             }
         }, 500);

     }

     jQuery(document).on('quick-view:open', function() {
         setTimeout(function() {
             const swiper = new Swiper('.product-badge-enable-swiper', {
                 loop: true,
                 autoplay: {
                     delay: 2000,
                     disableOnInteraction: false
                 },
                 effect: 'fade', // Optional: Use "slide" for default
                 fadeEffect: {
                     crossFade: true
                 },
                 slidesPerView: 1,
                 pagination: false,
                 navigation: false
             });
         }, 100);
         console.log("show quick==");

     });

 });

 function ClearCartDrawerSample() {
     console.log("clear cart fn===", event)
     $.getJSON('/cart.js', function(cart) {
         console.log(cart.total_price)
         if (cart.total_price <= 0) {
             $.ajax({
                 type: "GET",
                 url: '/cart/clear.js',
                 dataType: 'json',
                 success: function(data) {
                     document.dispatchEvent(new CustomEvent('cart:refresh'));
                     var url = window.location.href;
                     // console.log(url.indexOf("/cart"));
                     if (url.indexOf("/cart") > -1) {
                         location.reload(true);
                         return false;
                     }

                     console.log("cart cleared......here");
                 },
                 error: function(XMLHttpRequest, textStatus) {

                     console.log('error clearing');

                 }
             });

             return false;
         }
     })
 }
 // Mega-menu script start //
 var $targetElements = $(
     ".menu-drawer__item-link, " +
     ".v-scrollable.h-full.w-full.ss li a, " +
     ".mega-menu__item-child li a, " +
     ".mega-menu__link--top, " +
     ".mega-menu__promo-subheading, " +
     ".mega-menu-promotion-card .product-card__desc, " + 
     ".mega-menu-promotion-card .product-card__title a"
 );

 $targetElements.each(function() {
     var $this = $(this);
     var htmlContent = $this.html();

     if (htmlContent.indexOf("||") > -1) {
         var newHtml = htmlContent.replace(/\|\|(.*?)\|\|/g, function(match, capturedText) {
             var processedText = capturedText
                 .replace(/TM/g, "<span class='tm-jtpl'>TM</span>")
                 .replace(/®/g, "<span class='tm-jtpl'>®</span>");

             return "<strong>" + processedText + "</strong>";
         });

         $this.html(newHtml);
     }
 });
 // mega-menu script end//

 // Initialize Swiper Slider
 function initializeSwiper() {
     console.log("Swiper Slider inititialized")
     const swiperContainer = document.querySelector('.free-products-inner.custom-swiper');
     const isInitialized = jQuery('.free-products-inner.custom-swiper').hasClass("swiper-initialized")
     const productContainer = document.querySelector('.free-products-inner');
     const countFreeSample = parseInt(productContainer?.className.match(/count_free_sample-(\d+)/)?.[1] || 0);

     if (swiperContainer && countFreeSample >= 3 && !isInitialized) {
         console.log("Inside logic")
         // Initialize Swiper slider
         // if (swiperInstance) {
         //   swiperInstance.destroy(false, false);
         // }
         let carousel = new FoxTheme.Carousel(swiperContainer, {
             slidesPerView: 3,
             spaceBetween: 10,
             loop: true,
             pagination: {
                 el: swiperContainer.querySelector('.swiper-pagination'),
                 clickable: true,
             },
             navigation: {
                 nextEl: swiperContainer.querySelector('.swiper-button-next'),
                 prevEl: swiperContainer.querySelector('.swiper-button-prev'),
             },
             breakpoints: {
                 320: {
                     slidesPerView: 1,
                     spaceBetween: 10
                 },
                 640: {
                     slidesPerView: 2,
                     spaceBetween: 15
                 },
                 1024: {
                     slidesPerView: 3,
                     spaceBetween: 20
                 },
             }
         });
         carousel && carousel.init();
         console.log("carousel", carousel);


     } else if (productContainer && countFreeSample < 3) {
         productContainer.classList.remove('custom-swiper');
         productContainer.classList.add('grid-pro-jtpl');
     }
 }
 // jQuery(window).on('resize load', function() {
 //   initializeSwiper();
 // });
 //***************** quick-view productIngredients start ********************/ 
 jQuery(document).on('quick-view:open', function() {
     jQuery(document).on('click', '.quick-view__content .product-form__input label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".quick-view__content .product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
     });
 });
 //***************** quick-view productIngredients end ********************/ 




 // var KlarnaIntervalId = setInterval(function () {

 //   var klarnaElement = document.querySelector('klarna-placement');

 //   if (klarnaElement && klarnaElement.shadowRoot) {

 //       var shadow = klarnaElement.shadowRoot;

 //       if (!shadow.querySelector(".custom-klarna-style")) {

 //           var style = document.createElement("style");
 //           style.className = "custom-klarna-style";

 //           style.textContent = `
 //             .container {
 //               padding:4px 6px !important;
 //               background:#fff !important;
 //             }
 //             .container p{
 //               white-space:nowrap;
 //               font-family:var(--font-body-family);
 //             }
 //             .container p .logo{
 //               background:#ffb3c7;
 //               padding:6px;
 //               border-radius:4px;
 //             }
 //             .badge-container .badge{
 //               max-width:36px;
 //             }
 //             .text-wrapper{
 //               margin-left:6px;
 //             }
 //             .badge-container .badge svg{
 //               max-height:15px;
 //             }
 //             p, .link{
 //               font-size:12px !important;
 //               font-family: Helvetica,'Helvetica Neue',Arial,'Lucida Grande',sans-serif;
 //               color:#000;
 //             }
 //           `;

 //           shadow.appendChild(style);

 //           clearInterval(KlarnaIntervalId);
 //       }
 //   }

 // }, 500);




 if (window.jQuery) {
     var $ = window.jQuery;
 }
 document.addEventListener('DOMContentLoaded', function() {
     $("a[href='#']").click((e) => {
         e.preventDefault();
     })
     setTimeout(() => {
         document.querySelectorAll('video img').forEach(img => {
             img.setAttribute('alt', 'Video preview image');
             img.setAttribute('aria-hidden', 'true');

         });
         document.querySelectorAll(
             'a.cbb-frequently-bought-product-image-link[data-href]'
         ).forEach(link => {
             if (!link.getAttribute('href')) {
                 link.setAttribute('href', link.dataset.href);
                 link.setAttribute('aria-label', "Frequent bought product");
             }
         });
     }, 100);

     const interval = setInterval(() => {
         const el = document.querySelector(".zinrelo-tab");
         if (el) {
             el.style.color = "white";
             el.style.background = "black";
             clearInterval(interval);
         }
     }, 100);




     //  {% comment %} PDP JS START {% endcomment %}




     if (jQuery("body").hasClass("template-product")) {
         var handleReview = setInterval(ReviewBlock, 500);

         function ReviewBlock() {
             if (jQuery(".pr-snippet-rating-decimal").length > 0) {
                 var url = jQuery(".pr-snippet-write-review-link").attr("href");
                 jQuery("#write-a-review .pr-snippet-review-count").attr("href", url);
                 var get_count = parseInt(jQuery(".pr-snippet-rating-decimal").text());
                 if (get_count > 0) {
                     jQuery("div#write-a-review").attr("style", "display:none");
                 } else {
                     jQuery("div#write-a-review").attr("style", "display:block");
                 }
                 clearInterval(handleReview);
             }

         }

     }


     jQuery(".swatch-selected-color.active").click(function() {
         jQuery('.try-on-original-selector').trigger('click');
     });

     jQuery(document).on("click", ".legend-grid-list-main button", function() {
         jQuery(".legend-grid-list-main button").removeClass("active")
         jQuery(this).addClass("active")
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("fieldset.list-style").removeClass('active')
             jQuery("fieldset.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("fieldset.list-style").addClass('active')
             jQuery("fieldset.grid-style").removeClass("active")
         }
     });


     jQuery(document).on("click", ".product-grid-list-toggle button", function() {
         jQuery(".product-grid-list-toggle button").removeClass("active")
         jQuery(this).addClass("active");
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("#products-container-list.list-style").removeClass('active')
             jQuery("#products-container-grid.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("#products-container-list.list-style").addClass('active')
             jQuery("#products-container-grid.grid-style").removeClass("active")
         }
     });

     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatch-color-selected', function() {
         // Remove 'active' class from all swatches
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');

         // Toggle 'active' only on the clicked element's sibling swatches
         jQuery(this).siblings("ul.swatches").toggleClass("active");
         jQuery(this).parents(".custom-selector").toggleClass("active");

     });

     jQuery(document).on('click', '.grid-style label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         var option_value_text = jQuery(this).prev("input[type='radio']").attr("value");
         console.log(option_value_text);
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".list-style .product-form__input").find("select").val(option_value_text);

         jQuery(".swatches--product-card li").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         })
     });


     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatches .swatch-value', function(e) {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         let v_id = jQuery(this).data("v-id");
         let style = jQuery(this).find("a.swatch-color").attr("style");
         let option_value = jQuery(this).find(".option-badge-wrapper").html()
         let option_value_text = $.trim(jQuery(this).find(".option-badge-wrapper .option-value").text());
         //console.log("option_value===",option_value)
         let targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
         let targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
         targetColor.attr("style", style);
         // console.log("targetValue====",targetValue)
         targetValue.html(option_value);
         if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
             targetValue.addClass("has-badge");
         } else {
             targetValue.removeClass("has-badge")
         }

         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")

         return false;
     });

     //For color categories of product page
     jQuery(document).on("click", ".color-category-grid li.color-swatch", function() {
         console.log("Click===");
         let option_value_text = $.trim(jQuery(this).data("color"));
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")
         jQuery(".color-category-grid li.color-swatch").removeClass("active")
         jQuery(this).addClass("active")
         console.log("Color=00--", option_value_text)
         jQuery(".swatches--product-card li.swatch-value").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 console.log(option + "==---==" + option_value_text)
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         });
     });

     $("sticky-atc-bar select[name='id']").change(function(e) {
         e.preventDefault();
         let option_value_text = $("sticky-atc-bar select[name='id'] option:selected").text().trim();
         let v_id = $("sticky-atc-bar select[name='id'] option:selected").val()
         if ($("#products-container-list").length) {
             $(`#products-container-list li[data-v-id='${v_id}']`).trigger("click")
         } else {
             jQuery(".product-form__input").find("select").val(option_value_text);
             document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
                 bubbles: true
             }));
             console.log("Sticky change 11 --")
         }
     })

     //keep this js in end otherwise rest will break

     if (jQuery("klarna-placement").length > 0) {

         var KlarnaIntervalId = setInterval(function() {
             var klarnaElement = document.querySelector('klarna-placement');
             try {

                 if (klarnaElement) {
                     var host = klarnaElement.shadowRoot.querySelector("div.default");
                     // alert('host'+ host);
                     if (host) {
                         var style = document.createElement("style");
                         style.innerHTML = ".container {border-radius: 4px; padding: 4px 6px; background:#fff; width: fit-content; } .container p { white-space: nowrap; font-weight: 400; font-size: 12px; } .container p .logo{ background: #ffb3c7; padding: 6px; border-radius: 4px; } .badge-container .badge {max-width: 36px;} .text-wrapper {margin-left: 6px;} .badge-container .badge svg {max-height: 15px;}  p, p .link{ font-size: 12px !important; color: #000; font-weight: 400;} .link{ text-decoration: none; margin-left: 4px;}";
                         host.appendChild(style);
                         clearInterval(KlarnaIntervalId);
                     } else {
                         // console.log('.top-strip-promotion-auto-size not found inside shadow DOM');
                         clearInterval(KlarnaIntervalId);
                     }
                 } else {
                     // console.log('klarna-placement element or Shadow DOM not found');
                     clearInterval(KlarnaIntervalId);
                 }
             } catch (error) {

             }
         }, 500);

     }

     jQuery(document).on('quick-view:open', function() {
         setTimeout(function() {
             const swiper = new Swiper('.product-badge-enable-swiper', {
                 loop: true,
                 autoplay: {
                     delay: 2000,
                     disableOnInteraction: false
                 },
                 effect: 'fade', // Optional: Use "slide" for default
                 fadeEffect: {
                     crossFade: true
                 },
                 slidesPerView: 1,
                 pagination: false,
                 navigation: false
             });
         }, 100);
         console.log("show quick==");

     });

 });

 function ClearCartDrawerSample() {
     console.log("clear cart fn===", event)
     $.getJSON('/cart.js', function(cart) {
         console.log(cart.total_price)
         if (cart.total_price <= 0) {
             $.ajax({
                 type: "GET",
                 url: '/cart/clear.js',
                 dataType: 'json',
                 success: function(data) {
                     document.dispatchEvent(new CustomEvent('cart:refresh'));
                     var url = window.location.href;
                     // console.log(url.indexOf("/cart"));
                     if (url.indexOf("/cart") > -1) {
                         location.reload(true);
                         return false;
                     }

                     console.log("cart cleared......here");
                 },
                 error: function(XMLHttpRequest, textStatus) {

                     console.log('error clearing');

                 }
             });

             return false;
         }
     })
 }

 // Initialize Swiper Slider
 function initializeSwiper() {
     console.log("Swiper Slider inititialized")
     const swiperContainer = document.querySelector('.free-products-inner.custom-swiper');
     const isInitialized = jQuery('.free-products-inner.custom-swiper').hasClass("swiper-initialized")
     const productContainer = document.querySelector('.free-products-inner');
     const countFreeSample = parseInt(productContainer?.className.match(/count_free_sample-(\d+)/)?.[1] || 0);

     if (swiperContainer && countFreeSample >= 3 && !isInitialized) {
         console.log("Inside logic")
         // Initialize Swiper slider
         // if (swiperInstance) {
         //   swiperInstance.destroy(false, false);
         // }
         let carousel = new FoxTheme.Carousel(swiperContainer, {
             slidesPerView: 3,
             spaceBetween: 10,
             loop: true,
             pagination: {
                 el: swiperContainer.querySelector('.swiper-pagination'),
                 clickable: true,
             },
             navigation: {
                 nextEl: swiperContainer.querySelector('.swiper-button-next'),
                 prevEl: swiperContainer.querySelector('.swiper-button-prev'),
             },
             breakpoints: {
                 320: {
                     slidesPerView: 1,
                     spaceBetween: 10
                 },
                 640: {
                     slidesPerView: 2,
                     spaceBetween: 15
                 },
                 1024: {
                     slidesPerView: 3,
                     spaceBetween: 20
                 },
             }
         });
         carousel && carousel.init();
         console.log("carousel", carousel);


     } else if (productContainer && countFreeSample < 3) {
         productContainer.classList.remove('custom-swiper');
         productContainer.classList.add('grid-pro-jtpl');
     }
 }
 // jQuery(window).on('resize load', function() {
 //   initializeSwiper();
 // });
 //***************** quick-view productIngredients start ********************/ 
 jQuery(document).on('quick-view:open', function() {
     jQuery(document).on('click', '.quick-view__content .product-form__input label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".quick-view__content .product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
     });
 });
 //***************** quick-view productIngredients end ********************/ 




 // var KlarnaIntervalId = setInterval(function () {

 //   var klarnaElement = document.querySelector('klarna-placement');

 //   if (klarnaElement && klarnaElement.shadowRoot) {

 //       var shadow = klarnaElement.shadowRoot;

 //       if (!shadow.querySelector(".custom-klarna-style")) {

 //           var style = document.createElement("style");
 //           style.className = "custom-klarna-style";

 //           style.textContent = `
 //             .container {
 //               padding:4px 6px !important;
 //               background:#fff !important;
 //             }
 //             .container p{
 //               white-space:nowrap;
 //               font-family:var(--font-body-family);
 //             }
 //             .container p .logo{
 //               background:#ffb3c7;
 //               padding:6px;
 //               border-radius:4px;
 //             }
 //             .badge-container .badge{
 //               max-width:36px;
 //             }
 //             .text-wrapper{
 //               margin-left:6px;
 //             }
 //             .badge-container .badge svg{
 //               max-height:15px;
 //             }
 //             p, .link{
 //               font-size:12px !important;
 //               font-family: Helvetica,'Helvetica Neue',Arial,'Lucida Grande',sans-serif;
 //               color:#000;
 //             }
 //           `;

 //           shadow.appendChild(style);

 //           clearInterval(KlarnaIntervalId);
 //       }
 //   }

 // }, 500);




 if (window.jQuery) {
     var $ = window.jQuery;
 }
 document.addEventListener('DOMContentLoaded', function() {
     $("a[href='#']").click((e) => {
         e.preventDefault();
     })
     setTimeout(() => {
         document.querySelectorAll('video img').forEach(img => {
             img.setAttribute('alt', 'Video preview image');
             img.setAttribute('aria-hidden', 'true');

         });
         document.querySelectorAll(
             'a.cbb-frequently-bought-product-image-link[data-href]'
         ).forEach(link => {
             if (!link.getAttribute('href')) {
                 link.setAttribute('href', link.dataset.href);
                 link.setAttribute('aria-label', "Frequent bought product");
             }
         });
     }, 100);

     const interval = setInterval(() => {
         const el = document.querySelector(".zinrelo-tab");
         if (el) {
             el.style.color = "white";
             el.style.background = "black";
             clearInterval(interval);
         }
     }, 100);




     //  {% comment %} PDP JS START {% endcomment %}




     if (jQuery("body").hasClass("template-product")) {
         var handleReview = setInterval(ReviewBlock, 500);

         function ReviewBlock() {
             if (jQuery(".pr-snippet-rating-decimal").length > 0) {
                 var url = jQuery(".pr-snippet-write-review-link").attr("href");
                 jQuery("#write-a-review .pr-snippet-review-count").attr("href", url);
                 var get_count = parseInt(jQuery(".pr-snippet-rating-decimal").text());
                 if (get_count > 0) {
                     jQuery("div#write-a-review").attr("style", "display:none");
                 } else {
                     jQuery("div#write-a-review").attr("style", "display:block");
                 }
                 clearInterval(handleReview);
             }

         }

     }


     jQuery(".swatch-selected-color.active").click(function() {
         jQuery('.try-on-original-selector').trigger('click');
     });

     jQuery(document).on("click", ".legend-grid-list-main button", function() {
         jQuery(".legend-grid-list-main button").removeClass("active")
         jQuery(this).addClass("active")
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("fieldset.list-style").removeClass('active')
             jQuery("fieldset.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("fieldset.list-style").addClass('active')
             jQuery("fieldset.grid-style").removeClass("active")
         }
     });


     jQuery(document).on("click", ".product-grid-list-toggle button", function() {
         jQuery(".product-grid-list-toggle button").removeClass("active")
         jQuery(this).addClass("active");
         if (jQuery(this).hasClass("swatch-grid-style")) {
             jQuery("#products-container-list.list-style").removeClass('active')
             jQuery("#products-container-grid.grid-style").addClass("active")
         } else if (jQuery(this).hasClass("swatch-list-style")) {
             jQuery("#products-container-list.list-style").addClass('active')
             jQuery("#products-container-grid.grid-style").removeClass("active")
         }
     });

     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatch-color-selected', function() {
         // Remove 'active' class from all swatches
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').not(jQuery(this).siblings("ul.swatches")).removeClass('active');
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').not(jQuery(this).parents(".custom-selector")).removeClass('active');

         // Toggle 'active' only on the clicked element's sibling swatches
         jQuery(this).siblings("ul.swatches").toggleClass("active");
         jQuery(this).parents(".custom-selector").toggleClass("active");

     });

     jQuery(document).on('click', '.grid-style label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         var option_value_text = jQuery(this).prev("input[type='radio']").attr("value");
         console.log(option_value_text);
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".list-style .product-form__input").find("select").val(option_value_text);

         jQuery(".swatches--product-card li").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         })
     });


     jQuery(document).on('click', '.product-custom-jtpl.product-card__swatches.custom-selector .swatches .swatch-value', function(e) {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
         let v_id = jQuery(this).data("v-id");
         let style = jQuery(this).find("a.swatch-color").attr("style");
         let option_value = jQuery(this).find(".option-badge-wrapper").html()
         let option_value_text = $.trim(jQuery(this).find(".option-badge-wrapper .option-value").text());
         //console.log("option_value===",option_value)
         let targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
         let targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
         targetColor.attr("style", style);
         // console.log("targetValue====",targetValue)
         targetValue.html(option_value);
         if (jQuery(this).find(".option-badge-wrapper").hasClass("has-badge")) {
             targetValue.addClass("has-badge");
         } else {
             targetValue.removeClass("has-badge")
         }

         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")

         return false;
     });

     //For color categories of product page
     jQuery(document).on("click", ".color-category-grid li.color-swatch", function() {
         console.log("Click===");
         let option_value_text = $.trim(jQuery(this).data("color"));
         jQuery('.list-style span[data-selected-swatch-value="Color"]').text(option_value_text);
         jQuery(".product-form__input").find("select").val(option_value_text);
         document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
             bubbles: true
         }));
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector .swatches').removeClass("active")
         jQuery('.product-custom-jtpl.product-card__swatches.custom-selector').removeClass("active")
         jQuery(".color-category-grid li.color-swatch").removeClass("active")
         jQuery(this).addClass("active")
         console.log("Color=00--", option_value_text)
         jQuery(".swatches--product-card li.swatch-value").each(function() {
             var option = jQuery(this).attr("data-v-title");
             // console.log(option+"====="+option_value_text)
             if (option == option_value_text) {
                 console.log(option + "==---==" + option_value_text)
                 var style = jQuery(this).find("a.swatch-color").attr("style");
                 var option_value = jQuery(this).find(".option-badge-wrapper").html()
                 var targetColor = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value a.swatch-color");
                 var targetValue = jQuery(this).closest(".grid-list-container").find(".selected.swatch-value .option-badge-wrapper");
                 targetColor.attr("style", style);
                 targetValue.html(option_value);
                 return false;
             }

         });
     });

     $("sticky-atc-bar select[name='id']").change(function(e) {
         e.preventDefault();
         let option_value_text = $("sticky-atc-bar select[name='id'] option:selected").text().trim();
         let v_id = $("sticky-atc-bar select[name='id'] option:selected").val()
         if ($("#products-container-list").length) {
             $(`#products-container-list li[data-v-id='${v_id}']`).trigger("click")
         } else {
             jQuery(".product-form__input").find("select").val(option_value_text);
             document.querySelector(".product-form__input select").dispatchEvent(new Event('change', {
                 bubbles: true
             }));
             console.log("Sticky change 11 --")
         }
     })

     //keep this js in end otherwise rest will break

     if (jQuery("klarna-placement").length > 0) {

         var KlarnaIntervalId = setInterval(function() {
             var klarnaElement = document.querySelector('klarna-placement');
             try {

                 if (klarnaElement) {
                     var host = klarnaElement.shadowRoot.querySelector("div.default");
                     // alert('host'+ host);
                     if (host) {
                         var style = document.createElement("style");
                         style.innerHTML = ".container {border-radius: 4px; padding: 4px 6px; background:#fff; width: fit-content; } .container p { white-space: nowrap; font-weight: 400; font-size: 12px; } .container p .logo{ background: #ffb3c7; padding: 6px; border-radius: 4px; } .badge-container .badge {max-width: 36px;} .text-wrapper {margin-left: 6px;} .badge-container .badge svg {max-height: 15px;}  p, p .link{ font-size: 12px !important; color: #000; font-weight: 400;} .link{ text-decoration: none; margin-left: 4px;}";
                         host.appendChild(style);
                         clearInterval(KlarnaIntervalId);
                     } else {
                         // console.log('.top-strip-promotion-auto-size not found inside shadow DOM');
                         clearInterval(KlarnaIntervalId);
                     }
                 } else {
                     // console.log('klarna-placement element or Shadow DOM not found');
                     clearInterval(KlarnaIntervalId);
                 }
             } catch (error) {

             }
         }, 500);

     }

     jQuery(document).on('quick-view:open', function() {
         setTimeout(function() {
             const swiper = new Swiper('.product-badge-enable-swiper', {
                 loop: true,
                 autoplay: {
                     delay: 2000,
                     disableOnInteraction: false
                 },
                 effect: 'fade', // Optional: Use "slide" for default
                 fadeEffect: {
                     crossFade: true
                 },
                 slidesPerView: 1,
                 pagination: false,
                 navigation: false
             });
         }, 100);
         console.log("show quick==");

     });

 });

 function ClearCartDrawerSample() {
     console.log("clear cart fn===", event)
     $.getJSON('/cart.js', function(cart) {
         console.log(cart.total_price)
         if (cart.total_price <= 0) {
             $.ajax({
                 type: "GET",
                 url: '/cart/clear.js',
                 dataType: 'json',
                 success: function(data) {
                     document.dispatchEvent(new CustomEvent('cart:refresh'));
                     var url = window.location.href;
                     // console.log(url.indexOf("/cart"));
                     if (url.indexOf("/cart") > -1) {
                         location.reload(true);
                         return false;
                     }

                     console.log("cart cleared......here");
                 },
                 error: function(XMLHttpRequest, textStatus) {

                     console.log('error clearing');

                 }
             });

             return false;
         }
     })
 }

 // Initialize Swiper Slider
 function initializeSwiper() {
     console.log("Swiper Slider inititialized")
     const swiperContainer = document.querySelector('.free-products-inner.custom-swiper');
     const isInitialized = jQuery('.free-products-inner.custom-swiper').hasClass("swiper-initialized")
     const productContainer = document.querySelector('.free-products-inner');
     const countFreeSample = parseInt(productContainer?.className.match(/count_free_sample-(\d+)/)?.[1] || 0);

     if (swiperContainer && countFreeSample >= 3 && !isInitialized) {
         console.log("Inside logic")
         // Initialize Swiper slider
         // if (swiperInstance) {
         //   swiperInstance.destroy(false, false);
         // }
         let carousel = new FoxTheme.Carousel(swiperContainer, {
             slidesPerView: 3,
             spaceBetween: 10,
             loop: true,
             pagination: {
                 el: swiperContainer.querySelector('.swiper-pagination'),
                 clickable: true,
             },
             navigation: {
                 nextEl: swiperContainer.querySelector('.swiper-button-next'),
                 prevEl: swiperContainer.querySelector('.swiper-button-prev'),
             },
             breakpoints: {
                 320: {
                     slidesPerView: 1,
                     spaceBetween: 10
                 },
                 640: {
                     slidesPerView: 2,
                     spaceBetween: 15
                 },
                 1024: {
                     slidesPerView: 3,
                     spaceBetween: 20
                 },
             }
         });
         carousel && carousel.init();
         console.log("carousel", carousel);


     } else if (productContainer && countFreeSample < 3) {
         productContainer.classList.remove('custom-swiper');
         productContainer.classList.add('grid-pro-jtpl');
     }
 }
 // jQuery(window).on('resize load', function() {
 //   initializeSwiper();
 // });
 //***************** quick-view productIngredients start ********************/ 
 jQuery(document).on('quick-view:open', function() {
     jQuery(document).on('click', '.quick-view__content .product-form__input label[data-swatch-type="color_swatch"]', function() {
         var productIngredients = jQuery(this).attr("product-ingredients");
         if (productIngredients) {
             jQuery(".quick-view__content .product__block.product__block--collapsible_tab .accordion-details__content").eq(2).html(productIngredients);
         }
     });
 });
 //***************** quick-view productIngredients end ********************/ 




 $(document).on('click', '.pro-bundle-button', function(e) {
     e.preventDefault();
     var bundle_idd = $(this).siblings('.pro-bundle-hide').attr('product__id');
     var bundle_qty = $(this).siblings('.quantity-wrapper.border-radius-sharp').find('.selected_val_quantity').val();
     $(this).parents('.product-detail__form__action').addClass('top-slected-wrp');

     if (bundle_qty > 1) {
         $('.free-hide-label').attr('free_qty', bundle_qty);
         $('.step_text_wp.step_2 p em').html(bundle_qty);

         setTimeout(function() {
             $('[details_all_values]').flickity({
                 pageDots: false,
                 wrapAround: false,
                 arrows: true,
                 prevArrow: '<span class="slide-arrow prev-arrow"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="14.4 7.03 9 12.43 14.4 17.83" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline><title>svg</title></svg> </span>',
                 nextArrow: '<span class="slide-arrow next-arrow"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0-.25H24v24H0Z" transform="translate(0 0.25)" style="fill:none"></path><polyline points="10 17.83 15.4 12.43 10 7.03" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:8;stroke-width:2px"></polyline><title>svg</title></svg></span>',
                 cellAlign: 'left',
                 contain: true
             });
         }, 50);

         $('.bundle-free-product-cell').removeClass('jtpl_hidden');


         $.ajax({
             url: '/cart/add.js',
             type: 'POST',
             dataType: 'JSON',
             data: {
                 id: bundle_idd,
                 quantity: bundle_qty
             },
             success: function() {
                 console.log('success');
             },
             error: function() {
                 console.log('fail');
             }
         });

         $('html, body').animate({
             scrollTop: $('.bundle-free-product-cell').offset().top - 50
         }, 'slow');
     } else {
         alert("Please add at least two eye liners!");
         console.log("small");
     }
 });

 $(document).on('click', '.free-pro-image a', function(e) {
     e.preventDefault();
     var $parent = $(this).parents('.free-product-cell-inner');
     if ($parent.find('.choose-to-add-bundle').hasClass('jtpl_hidden')) {
         $parent.find('.check-image-jtpl').trigger('click');
     } else {
         $parent.find('.choose-to-add-bundle').trigger('click');
     }
 });

 $(document).on('click', '.free-bundnle-select span', function() {
     var $select = $(this).parents('.free-bundnle-select');
     $select.addClass('free_selected_wp');
     $(this).toggleClass('jtpl_hidden');
     $(this).siblings('.check-image-jtpl').toggleClass('jtpl_hidden');

     var free_check_count = $('.free-bundnle-select.free_selected_wp').length;
     var chk_select_id = $('.free-hide-label').attr('free_qty');

     if (free_check_count > 1) {
         if (chk_select_id == free_check_count) {
             $('.free-pro-check').removeClass('chk_pro_wrap_jt');
             $('.free-pro-image').addClass('img_click_disable');
             $('.cart-drawer-btn').removeClass('jtpl_hidden');
             $('html, body').animate({
                 scrollTop: $('.cart-drawer-btn').offset().top - 500
             }, 'slow');
         } else {
             $('.free-pro-check').addClass('chk_pro_wrap_jt');
             $('.free-pro-image').removeClass('img_click_disable');
         }
     } else {
         $('.cart-drawer-btn').addClass('jtpl_hidden');
     }
 });

 $(document).ready(function() {
     $('.quantity-wrapper.border-radius-sharp').find('.increase-quantity').on('click', function() {
         var quantityInput = $('.bundle-pro-bundle');
         var currentValue = parseInt(quantityInput.val());
         quantityInput.val(currentValue + 1);
     });

     $('.quantity-wrapper.border-radius-sharp').find('.decrease-quantity').on('click', function() {
         var quantityInput = $('.bundle-pro-bundle');
         var currentValue = parseInt(quantityInput.val());
         if (currentValue > 1) {
             quantityInput.val(currentValue - 1);
         }
     });
 });


 $(document).on('click', '.free-bundnle-select img', function() {
     var $select = $(this).parents('.free-bundnle-select');
     $select.removeClass('free_selected_wp');
     $(this).toggleClass('jtpl_hidden');
     $(this).siblings('.free-bundnle-select span').toggleClass('jtpl_hidden');

     var free_check_count2 = $('.free-bundnle-select.free_selected_wp').length;
     var chk_select_id2 = $('.free-hide-label').attr('free_qty');

     if (free_check_count2 >= 2) {
         $('.cart-drawer-btn').removeClass('jtpl_hidden');

         if (chk_select_id2 == free_check_count2) {
             $('.free-pro-check').removeClass('chk_pro_wrap_jt');
             $('.free-pro-image').addClass('img_click_disable');
         } else {
             $('.free-pro-check').addClass('chk_pro_wrap_jt');
             $('.free-pro-image').removeClass('img_click_disable');
         }
     }
 });

 $(document).on('click', '[show-bundle-btn_clk]', function() {
     var free_id_get = $(this).siblings('.free-hide-label').val();
 });




 document.addEventListener("DOMContentLoaded", () => {
     document.body.classList.add("page-loaded");
 });




 // var KlarnaIntervalId = setInterval(function () {

 //   var klarnaElement = document.querySelector('klarna-placement');

 //   if (klarnaElement && klarnaElement.shadowRoot) {

 //       var shadow = klarnaElement.shadowRoot;

 //       if (!shadow.querySelector(".custom-klarna-style")) {

 //           var style = document.createElement("style");
 //           style.className = "custom-klarna-style";

 //           style.textContent = `
 //             .container {
 //               padding:4px 6px !important;
 //               background:#fff !important;
 //             }
 //             .container p{
 //               white-space:nowrap;
 //               font-family:var(--font-body-family);
 //             }
 //             .container p .logo{
 //               background:#ffb3c7;
 //               padding:6px;
 //               border-radius:4px;
 //             }
 //             .badge-container .badge{
 //               max-width:36px;
 //             }
 //             .text-wrapper{
 //               margin-left:6px;
 //             }
 //             .badge-container .badge svg{
 //               max-height:15px;
 //             }
 //             p, .link{
 //               font-size:12px !important;
 //               font-family: Helvetica,'Helvetica Neue',Arial,'Lucida Grande',sans-serif;
 //               color:#000;
 //             }
 //           `;

 //           shadow.appendChild(style);

 //           clearInterval(KlarnaIntervalId);
 //       }
 //   }

 // }, 500);




 function updateSwiperByVariant(variant, container = document) {
     if (!variant) return;

     const swiperEl = container.querySelector('.product__media-list');
     const swiper = swiperEl?.swiper;

     if (!swiper) return;

     swiper.update();

     if (swiper.thumbs && swiper.thumbs.swiper) {
         swiper.thumbs.swiper.update();
     }

     // ✅ ALWAYS FIRST IMAGE
     if (swiper.slideToLoop) {
         swiper.slideToLoop(0, 0); // for loop mode
     } else {
         swiper.slideTo(0, 0);
     }
 }




 // function updateSwiperByVariant(variant, container = document) {
 //   if (!variant || !variant.featured_media) return;

 //   const swiperEl = container.querySelector('.swiper');
 //   const swiper = swiperEl?.swiper;

 //   if (!swiper) return;

 //   // DO NOT hide slides

 //   swiper.update();

 //   if (swiper.thumbs && swiper.thumbs.swiper) {
 //     swiper.thumbs.swiper.update();
 //   }

 //   // Go to correct image

 //   const targetSlide = swiper.slides.find(
 //     slide => slide.dataset.mediaId == variant.featured_media.id
 //   );

 //   if (targetSlide) {
 //     const index = targetSlide.swiperSlideIndex;
 //     swiper.slideTo(index, 0);
 //   }


 //   //  swiper.slideTo(0, 0);
 // }




 document.addEventListener('variant:changed', function(evt) {
     const variant = evt.detail?.variant;
     console.log("variant--->" + variant);
     const drawer = document.querySelector('.quick-view[open], .drawer.is-open');
     // console.log("drawer---->"+drawer);
     const container = drawer || document;
     // console.log("container---->"+container);
     updateSwiperByVariant(variant, container);

        if(drawer){
            const swiperEl = document.querySelector(".drawer__inner .product__media-gallery-viewer.swiper");
            if (swiperEl && swiperEl.swiper) {
                swiperEl.swiper.slideTo(0, 0); // first slide 
                // swiperEl.swiper.slideToLoop(0, 0); // agar loop: true hai
            }
        }

        const mainProduct = !drawer;
        if (mainProduct) {
            updateGalleryByVariant(event.detail.variant);
        }

 });


 function formatVideoD(url) {
     if (!url) return '';
     if (url.includes('youtu.be/')) return 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1].split('?')[0];
     if (url.includes('watch?v=')) return 'https://www.youtube.com/embed/' + url.split('watch?v=')[1].split('&')[0];
     if (url.includes('/shorts/')) return 'https://www.youtube.com/embed/' + url.split('/shorts/')[1].split('?')[0];
     if (url.includes('vimeo.com/')) return 'https://player.vimeo.com/video/' + url.split('vimeo.com/')[1].split('?')[0];
     return url;
 }

 function updateVideoThumbnail(finalVideo, finalImg) {
     console.log(`finalVideo=>>>>>>>>>>>>${finalVideo}`);
     console.log(`finalCover=>>>>>>>>>>>>${finalImg}`);
     const thumbItemContainer = document.querySelector('.product__thumbs-item[data-is-video="true"] .product__thumbs-inner');
     if (!thumbItemContainer) return;

     const existingImg = thumbItemContainer.querySelector('img');
     if (existingImg) existingImg.remove();

     let thumbSrc = finalImg || '';
     if (thumbSrc && !thumbSrc.startsWith('http')) {
         thumbSrc = thumbSrc.includes('files/') ? `https://cdn.shopify.com/s/files/1/2220/7229/${thumbSrc}` : `https://cdn.shopify.com/s/files/1/2220/7229/files/${thumbSrc}`;
     }
     console.log(`thumbSrc=>>>>>>>>>>>>${thumbSrc}`);
     if (!thumbSrc && finalVideo.includes('youtu')) {

         let videoId = finalVideo;
         if (videoId.includes("youtu.be")) videoId = videoId.split("/").pop().split("?")[0];
         else if (videoId.includes("/watch?v=")) videoId = videoId.split("/watch?v=")[1].split("&")[0];
         else if (videoId.includes("/shorts/")) videoId = videoId.split("/shorts/")[1].split("?")[0].split("&")[0];
         else videoId = videoId.split('/').pop();
         thumbSrc = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
     }

     if (!thumbSrc) thumbSrc = 'https://cdn.shopify.com/s/files/1/2220/7229/files/video_1.png?v=1773914158';

     const imgEl = document.createElement('img');
     imgEl.src = thumbSrc;
     imgEl.alt = 'Video thumbnail';
     imgEl.loading = 'lazy';
     thumbItemContainer.prepend(imgEl);
 }

 document.addEventListener('DOMContentLoaded', function() {
     // Collection Filter Logic
     const hideBtn = document.querySelector(".hide-filters");
     const showBtn = document.querySelector(".show-filters");
     const filterContainer = document.getElementById("FacetFiltersContainer");

     if (hideBtn && filterContainer && showBtn) {
         hideBtn.addEventListener("click", function() {
             filterContainer.style.display = "none";
             showBtn.classList.remove("hidden");
         });
     }
     if (showBtn && filterContainer) {
         showBtn.addEventListener("click", function() {
             filterContainer.style.display = "block";
             showBtn.classList.add("hidden");
         });
     }

     // Variant Initialization Logic
     let initialVariant = null;
     if (window.initialVariantId && window.productVariants?.length) {
         initialVariant = window.productVariants.find(v => v.id == window.initialVariantId);
     }
     if (!initialVariant && window.productVariants?.length) {
         initialVariant = window.productVariants[0];
     }

     updateGalleryByVariant(initialVariant);
     if (typeof updateSwiperByVariant === "function") {
         updateSwiperByVariant(initialVariant);
     }

     // 🔥 PLAY CLICK FUNCTION (UNMUTE VIA JS API WITHOUT RELOADING) 🔥
     document.addEventListener('click', function(e) {
         const cover = e.target.closest('.main-slide-cover-jt');
         const videoItem = e.target.closest('.product__media-item[data-is-video="true"]');

         if (cover || videoItem) {
             const wrapper = (cover || videoItem).closest('.custom-video-wrapper-jt');
             if (wrapper) {
                 wrapper.classList.add('video-playing-jt');
                 wrapper.setAttribute('data-manual-played', 'true');

                 const iframe = wrapper.querySelector('.main-iframe-jt');
                 if (iframe) {
                     // Agar iframe khali h toh source set karo
                     if (iframe.src === 'about:blank' || iframe.src === '') {
                         const playUrl = iframe.getAttribute('data-src');
                         if (playUrl) iframe.src = playUrl.replace('mute=1', 'mute=0'); // Unmute URL structure
                     } else {
                         // Agar pehle se chal rhi h toh postMessage se instantly unmute karo bina reload kiye
                         iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
                         iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                     }
                 }
                 const video = wrapper.querySelector('video');
                 if (video) {
                     video.muted = false;
                     if (video.paused) {
                         // video.play().catch(err => console.log('MP4 audio context open'));
                         video.play().catch(() => {});
                     }
                 }
             }
         }
     });

     // 🔥 CORE SLIDER SYNC AND MUTED AUTOPLAY ENGINE 🔥
     // window.trackActiveVideoSlideState = function() {
     //   const videoSlide = document.querySelector('.product__media-item[data-is-video="true"]');
     //   if (!videoSlide) return;

     //   const schemaAutoplay = (window.schemaAutoplayEnabled === true || window.schemaAutoplayEnabled === 'true');
     //   const isCurrentlyActive = videoSlide.classList.contains('swiper-slide-active') || 
     //                             (videoSlide.style.display !== 'none' && !document.querySelector('.product__media-gallery-viewer.swiper'));

     //   const videoEl = videoSlide.querySelector('video');
     //   const iframeEl = videoSlide.querySelector('iframe');
     //   const wrapper = videoSlide.querySelector('.custom-video-wrapper-jt');

     //   if (isCurrentlyActive) {
     //     if (videoSlide.getAttribute('data-manual-played') === 'true') return;

     //     if (schemaAutoplay) {
     //       if (videoEl && videoEl.paused) {
     //         videoEl.muted = true; // Safely trigger muted autoplay for MP4
     //         videoEl.play().catch(e => console.log('HTML5 Autoplay handled'));
     //       }
     //       if (iframeEl && (iframeEl.src === 'about:blank' || iframeEl.src === '')) {
     //         const targetSrc = iframeEl.getAttribute('data-src');
     //         if (targetSrc) {
     //           videoSlide.classList.add('video-playing-jt');
     //           if (wrapper) wrapper.classList.add('video-playing-jt');
     //           iframeEl.src = targetSrc; // Loads muted natively to bypass search/live block restrictions
     //         }
     //       }
     //     }
     //   } else {
     //     // RESET ALL SLIDES AND CSS COVER WRAPPERS SAFE
     //     videoSlide.removeAttribute('data-manual-played');
     //     videoSlide.classList.remove('video-playing-jt');
     //     if (wrapper) wrapper.classList.remove('video-playing-jt');

     //     if (videoEl) {
     //       if (!videoEl.paused) videoEl.pause();
     //       videoEl.muted = true;
     //     }
     //     if (iframeEl && iframeEl.src !== 'about:blank') {
     //       iframeEl.src = 'about:blank';
     //     }
     //   }
     // }

     // Hook Swiper Lifecycle safely
     setTimeout(function() {
         const gallerySwiper = document.querySelector('.product__media-gallery-viewer.swiper');
         if (gallerySwiper && gallerySwiper.swiper) {
             gallerySwiper.swiper.on('slideChange', window.trackActiveVideoSlideState);
             gallerySwiper.swiper.on('transitionEnd', window.trackActiveVideoSlideState);
         }
     }, 1200);

     document.addEventListener('click', function(e) {
         if (e.target.closest('.product__thumbs-item') || e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev')) {
             setTimeout(window.trackActiveVideoSlideState, 150);
         }
     });
 });

 function updateGalleryByVariant(variant) {
     if (!variant) variant = {
         id: null,
         title: ''
     };
     const isDefaultVariant = !window.productVariants || window.productVariants.length <= 1;

     const key = '#color_' + (variant.title || '').toLowerCase().replace(/[\/]+/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w-]/g, '').replace(/\bamp-\b/gi, '').replace(/&/g, '').replace(/-+/g, '-').trim();
     let firstVisibleIndex = -1;

     const variantData = Array.isArray(window.productVariants) && variant.id ? window.productVariants.find(v => v.id == variant.id) : null;
     const variantVideo = (variantData && (variantData.youtube_video || variantData.youtube_video_url_variants_)) ? (variantData.youtube_video || variantData.youtube_video_url_variants_) : '';
     const variantImg = variantData ? (variantData.cover_image || variantData.featured_image) : '';

     const productVideo = window.productGlobalVideo || window.productVideo || '';
     const finalVideo = variantVideo || productVideo;
     const productImg = window.productGlobalCover || window.productVideoImg || '';

     let setupImg = variantVideo !== '' ? (variantImg || '') : (variantImg || productImg || '');

     if (setupImg && typeof setupImg === 'object') setupImg = setupImg.url || setupImg.src || '';
     if (setupImg && typeof setupImg === 'string' && !setupImg.startsWith('http')) {
         setupImg = setupImg.trim();
         setupImg = setupImg.startsWith('files/') ? `https://cdn.shopify.com/s/files/1/2220/7229/${setupImg}` : `https://cdn.shopify.com/s/files/1/2220/7229/files/${setupImg}`;
     }

     let finalImg = setupImg;
     let finalYoutubeId = finalVideo;
     if (finalYoutubeId.includes("youtu.be")) finalYoutubeId = finalYoutubeId.split("/").pop().split("?")[0];
     else if (finalYoutubeId.includes("/watch?v=")) finalYoutubeId = finalYoutubeId.split("/watch?v=")[1].split("&")[0];
     else if (finalYoutubeId.includes("/shorts/")) finalYoutubeId = finalYoutubeId.split("/shorts/")[1].split("?")[0].split("&")[0];

     if (!finalImg || finalImg === '') {
         finalImg = finalVideo.includes('youtu') ? `https://img.youtube.com/vi/${finalYoutubeId}/hqdefault.jpg` : 'https://cdn.shopify.com/s/files/1/2220/7229/files/video_1.png?v=1773914158';
     }

     updateVideoThumbnail(finalVideo, finalImg);

     // Main Images Visibility Filter
     document.querySelectorAll('.product__media-item').forEach((item, index) => {
         if (isDefaultVariant) {
             item.style.display = '';
             if (firstVisibleIndex === -1) firstVisibleIndex = index;
             return;
         }
         const alt = (item.dataset.variantAlt || '').toLowerCase();
         if (alt === key || item.dataset.isVideo === "true") {
             item.style.display = '';
             if (firstVisibleIndex === -1) firstVisibleIndex = index;
         } else {
             item.style.display = 'none';
         }
     });

     if (window.productSwiper) {
         window.productSwiper.update();
         window.productSwiper.slideTo(0);
     }

     // Thumbnails Filter
     document.querySelectorAll('.product__thumbs-item').forEach((item) => {
         if (isDefaultVariant) {
             item.style.display = '';
             return;
         }
         const alt = (item.dataset.variantAlt || '').toLowerCase();
         if (alt.includes(key)) item.style.display = '';
         else if (item.dataset.isVideo === "true") item.style.display = finalVideo ? '' : 'none';
         else item.style.display = 'none';
     });

     // Force Order Stability (Position 2)
     const gallery = document.querySelector('.product__media-list');
     const videoItem = document.querySelector('.product__media-item[data-is-video="true"]');
     if (gallery && videoItem) {
         const visibleItems = Array.from(gallery.querySelectorAll('.product__media-item')).filter(item => item.style.display !== 'none' && !item.classList.contains('swiper-slide-duplicate'));
         if (visibleItems.length > 1) gallery.insertBefore(videoItem, visibleItems[2]);
     }

     const videoThumb = document.querySelector('.product__thumbs-item[data-is-video="true"]');
     if (videoThumb) {
         const thumbsWrapper = videoThumb.closest('.swiper-wrapper') || videoThumb.parentElement;
         if (thumbsWrapper) {
             const items = Array.from(thumbsWrapper.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)')).filter(item => item.style.display !== 'none');

             if (items.length > 2) thumbsWrapper.insertBefore(videoThumb, items[2]);
         }
     }
     // const videoThumb = document.querySelector('.product__thumbs-item[data-is-video="true"]');
     // if (videoThumb) {
     //   const thumbsWrapper = videoThumb.closest('.swiper-wrapper') || videoThumb.parentElement;
     //   if (thumbsWrapper) {
     //     const items = Array.from(thumbsWrapper.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)'))
     //       .filter(item => item.style.display !== 'none' && item !== videoThumb); // self excluded

     //     if (items.length >= 1) {
     //       thumbsWrapper.insertBefore(videoThumb, items[1] || null); // 👈 force before 2nd non-video item = index 1
     //     } else {
     //       thumbsWrapper.appendChild(videoThumb);
     //     }
     //   }
     // }
     // Inject Layout Element Structure safely with enablejsapi=1 parameter
     console.log(`<<<<<<<<<<<variant id=>>>>${variant.id}`);
     let hasMedia = false;

     $('.variant_media_swatch').each(function() {
         const variantId = $(this).attr('var_id');

         if (variantId == variant.id) { // variant.id should be available in your JS
             const proMeta = $(this).attr('pro_meta');
             const variantMeta = $(this).attr('variant_meta');
             firstMedia = $(this).attr('media_video');
             if (proMeta || variantMeta || firstMedia) {
                 hasMedia = true;
             } else {
                 hasMedia = false;
             }

             return false; // break loop
         }
     });

     console.log(hasMedia);
     if (hasMedia) {
  
         let videoContainer = null;
         let finalVideo1 = '';

         document.querySelectorAll('.variant_media_swatch').forEach((swatch) => {
             if (swatch.getAttribute('var_id') == variant.id) {
                 varBanner = swatch.getAttribute('var_banner');
                 prodBanner = swatch.getAttribute('prod_banner');
                
                 isVarBanner = varBanner !== null && varBanner.trim() !== '';
                 isprodBanner = prodBanner !== null && prodBanner.trim() !== '';
                 videoContainer = swatch.querySelector(
                     '.product__media-item012[data-is-video="true"] .product__media'
                 );

                 const video = swatch.querySelector('video[data-video-url]');
                 const iframe = swatch.querySelector('.main-iframe-jt');

                 if (video) {
                     finalVideo1 = video.getAttribute('data-video-url') || '';
                 } else if (iframe) {
                     finalVideo1 = iframe.getAttribute('src') || '';
                 }
             }
         });

         if (videoContainer && finalVideo1) {
           
             videoContainer.innerHTML = '';
             console.log(`finalVideo100963 => ${finalVideo1}`);
             if (finalVideo1.endsWith('.mp4') || finalVideo1.includes('.mp4')) {
                 const videoEl = document.createElement('video');
                 videoEl.setAttribute('controls', '');
                 videoEl.setAttribute('muted', '');
                 videoEl.setAttribute('loop', '');
                 videoEl.setAttribute('playsinline', '');
                 videoEl.style.cssText = 'position: absolute !important; top:0; left:0; width:100% !important; height:100% !important; z-index:10 !important;';
                 if (finalImg && !finalImg.includes('video_1.png')) videoEl.setAttribute('poster', finalImg);

                 const sourceEl = document.createElement('source');
                 sourceEl.src = finalVideo1;
                 sourceEl.type = 'video/mp4';
                 videoEl.appendChild(sourceEl);
                 videoContainer.appendChild(videoEl);

                 console.log(`videoContainer is here =>> ${videoContainer}`);
             } else {
                 // videoContainer.innerHTML = `
                 //   <div class="custom-video-wrapper-jt" style="position: relative !important; width:100% !important; height:100% !important; display:block !important;">
                 //     <div class="main-slide-cover-jt">
                 //       <img src="${finalImg}" alt="Video Cover">
                 //       <div class="play-btn-overlay-jt">
                 //         <svg viewBox="0 0 36 36" height="32px" width="32px" fill="#FFF">   
                 //           <path d="M32.16,16.08,8.94,4.47A2.07,2.07,0,0,0,6,6.32V29.53a2.06,2.06,0,0,0,3,1.85L32.16,19.77a2.07,2.07,0,0,0,0-3.7Z"></path>
                 //         </svg>
                 //       </div>
                 //     </div>
                 //     <iframe class="main-iframe-jt" data-src="https://www.youtube.com/embed/${finalYoutubeId}?autoplay=1&mute=1&loop=1&playlist=${finalYoutubeId}&enablejsapi=1&rel=0" src="about:blank" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                 //   </div>`;

                 let finalYoutubeId = finalVideo1;

                 if (finalYoutubeId.includes("youtu.be")) {
                     finalYoutubeId = finalYoutubeId.split("/").pop().split("?")[0];
                 } else if (finalYoutubeId.includes("/watch?v=")) {
                     finalYoutubeId = finalYoutubeId.split("/watch?v=")[1].split("&")[0];
                 } else if (finalYoutubeId.includes("/shorts/")) {
                     finalYoutubeId = finalYoutubeId.split("/shorts/")[1].split("?")[0].split("&")[0];
                 } else if (finalYoutubeId.includes("/embed/")) {
                     finalYoutubeId = finalYoutubeId.split("/embed/")[1].split("?")[0].split("&")[0];
                 }

                 const finalImg1 = `https://img.youtube.com/vi/${finalYoutubeId}/hqdefault.jpg`;

                 console.log(finalYoutubeId);
                 console.log(finalImg1);
                 console.log(`==================unique finalImg1 ${finalImg1}`);

                 videoContainer.innerHTML = `
                  <div class="custom-video-wrapper-jt av007" style="position: relative !important; width:100% !important; height:100% !important; display:block !important;">
                    <div class="main-slide-cover-jt">
                      <img src="${finalImg}" alt="Video Cover">
                      <div class="play-btn-overlay-jt">
                        <svg viewBox="0 0 36 36" height="32px" width="32px" fill="#FFF">   
                          <path d="M32.16,16.08,8.94,4.47A2.07,2.07,0,0,0,6,6.32V29.53a2.06,2.06,0,0,0,3,1.85L32.16,19.77a2.07,2.07,0,0,0,0-3.7Z"></path>
                        </svg>
                      </div>
                    </div>
                    <iframe class="main-iframe-jt" 
                  src="https://www.youtube.com/embed/${finalYoutubeId}?autoplay=0&mute=1&playsinline=1&loop=1&playlist=${finalYoutubeId}&enablejsapi=1&rel=0"
                    frameborder="0" 
                    allow="autoplay; 
                    encrypted-media" 
                    allowfullscreen>
                    </iframe>
                  </div>`;
                 // Video slide (jo move karni hai)
                 const videoThumb = document.querySelector('.product__thumbs-item[data-is-video="true"]');


                 const mediaItems = [...document.querySelectorAll('.product__media-item')]
                     .filter(item => getComputedStyle(item).display !== 'none');

                 // Agar video slide pehle se hai to dobara mat banao
                 if (!document.querySelector('.product__media-item.video-playing-jt')) {
                     
                     const html = `
          <div class="product__media-item swiper-slide not-mobile custom-video-wrapper-jt video-playing-jt cstm-video"
              data-is-video="true"
              data-variant-alt="video"
              style="cursor:pointer;position:relative;">
              ${videoContainer.outerHTML}
          </div>
          `;

                     if (mediaItems.length >= 2) {
                         mediaItems[1].insertAdjacentHTML('beforebegin', html);
                     } else if (mediaItems.length === 1) {
                         mediaItems[0].insertAdjacentHTML('afterend', html);
                     }

                 } else {
                     
                     const existingContainer = document.querySelector(
                         '.product__media-item.video-playing-jt .product__media'
                     );

                     if (existingContainer) {
                         existingContainer.innerHTML = videoContainer.innerHTML;
                     }

                     // Existing video slide
                     const videoSlide = document.querySelector('.product__media-item.video-playing-jt');

                     if (videoSlide) {

                         // Content update
                         const existingContainer = videoSlide.querySelector('.product__media');
                         if (existingContainer) {
                             existingContainer.innerHTML = videoContainer.innerHTML;
                         }

                         // Visible media items (video slide ko exclude karke)
                         const mediaItems = [...document.querySelectorAll('.product__media-item')]
                             .filter(item =>
                                 item !== videoSlide &&
                                 getComputedStyle(item).display !== 'none'
                             );

                         // Current position se hatao


                         videoSlide.remove();



                         // Hamesha second visible index par lagao
                         if (mediaItems.length >= 2) {
                             mediaItems[1].before(videoSlide);
                         } else if (mediaItems.length === 1) {
                             mediaItems[0].after(videoSlide);
                         }
                     }
                 }
                 if (videoThumb) {
                     
                     // Existing logic...
                     const visibleThumbs = [...document.querySelectorAll('.product__thumbs-item')]
                         .filter(item =>
                             item !== videoThumb &&
                             getComputedStyle(item).display !== 'none'
                         );
                     if (!firstMedia) {
                         videoThumb.remove();
                     }

                   


                     if (visibleThumbs.length >= 2) {
                         visibleThumbs[1].before(videoThumb);
                     } else if (visibleThumbs.length === 1) {
                         visibleThumbs[0].after(videoThumb);
                     } else {
                         document.querySelector('.product__thumbs-item').parentNode.appendChild(videoThumb);
                     }

                     setTimeout(() => {
                         if (isVarBanner) {
                          
                             let finalImg1 = varBanner
                             if (firstMedia) {
                                 document.querySelectorAll('[data-variant-alt="video"]').forEach(el => {
                                     let parent = el.closest('.product__thumbs-item');

                                     if (parent) {
                                         parent.style.setProperty('display', 'block', 'important');
                                         parent.removeAttribute('hidden');
                                     }
                                 });
                             }
                             updateVideoThumbnail(finalVideo1, finalImg1);
                         } else if (isprodBanner) {
                             let finalImg1 = prodBanner
                             if (firstMedia) {
                                 document.querySelectorAll('[data-variant-alt="video"]').forEach(el => {
                                     let parent = el.closest('.product__thumbs-item');

                                     if (parent) {
                                         parent.style.setProperty('display', 'block', 'important');
                                         parent.removeAttribute('hidden');
                                     }
                                 });
                             }
                             updateVideoThumbnail(finalVideo1, finalImg1);
                         } else {

                             if (firstMedia) {
                             
                                 // const visibleThumbs = [...document.querySelectorAll('.product__thumbs-item')]
                                 // .filter(item => window.getComputedStyle(item).display !== 'none');

                                 // visibleThumbs.forEach(item => item.removeAttribute('data-is-video'));

                                 // if (visibleThumbs[1]) {
                                 //   visibleThumbs[1].setAttribute('data-is-video', 'true');
                                 // }

                                 document.querySelectorAll('[data-variant-alt="video"]').forEach(el => {
                                     let parent = el.closest('.product__thumbs-item');

                                     if (parent) {
                                         parent.style.setProperty('display', 'block', 'important');
                                         parent.removeAttribute('hidden');
                                     }
                                 });
                                 console.log(`finalMedia056=> ${firstMedia}`);
                                 console.log(`finalImg056=> ${finalImg1}`);
                                 updateVideoThumbnail(firstMedia, finalImg1);
                             } else {
                                
                                 if (!finalImg1.includes('https')) {
                              
                                     // Yeh code tabhi chalega jab finalImg1 mein https nahi hoga
                                     console.log(`here it is 007=> ${finalImg1}`);
                                     updateVideoThumbnail(finalVideo1, finalImg1);

                                 }

                             }

                         }

                     }, 300);

                 } else {
                    
                     const visibleThumbs = [...document.querySelectorAll('.product__thumbs-item')]
                         .filter(item => getComputedStyle(item).display !== 'none');

                     const thumbHtml = `
                        <div class="product__thumbs-item swiper-slide not-mobile"
                            data-is-video="true"
                            data-variant-alt="video"
                            style="height:125.5px;margin-bottom:10px;">
                            <div class="product__thumbs-container medium-blocks-radius media-wrapper">
                                <div class="product__thumbs-inner" style="--aspect-ratio:1">
                                    <img src="${finalImg1}" alt="Video thumbnail" loading="lazy">
                                    <span class="video-play-icon"></span>
                                </div>
                            </div>
                        </div>`;

                     if (visibleThumbs.length >= 2) {

                         // Second thumbnail remove
                         if (!firstMedia) {
                             visibleThumbs[1].remove();
                         }
                         // Uski jagah video thumbnail
                         visibleThumbs[0].insertAdjacentHTML('afterend', thumbHtml);

                     } else if (visibleThumbs.length === 1) {

                         visibleThumbs[0].insertAdjacentHTML('afterend', thumbHtml);

                     } else {

                         document.querySelector('.product__thumbs').insertAdjacentHTML('beforeend', thumbHtml);
                     }
                     const visibleSlides = [...document.querySelectorAll('.product__media-item')]
                         .filter(item =>
                             !item.classList.contains('video-playing-jt') &&
                             getComputedStyle(item).display !== 'none'
                         );

                     if (visibleSlides.length >= 2) {
                         if (!firstMedia) {
                             visibleSlides[1].remove();
                         }
                     }
                     setTimeout(() => {
                         if (isVarBanner) {
                             
                             let finalImg1 = varBanner
                             updateVideoThumbnail(finalVideo1, finalImg1);
                         } else if (isprodBanner) {
                             let finalImg1 = prodBanner
                             updateVideoThumbnail(finalVideo1, finalImg1);
                         } else {
                            
                             if (firstMedia) {
                                 console.log(`finalMedia007=> ${firstMedia}`);
                                 console.log(`finalImg007=> ${finalImg1}`);
                                 updateVideoThumbnail(firstMedia, finalImg1);
                             } else {
                                 if (!finalImg1.includes('https')) {
                                    
                                     // Yeh code tabhi chalega jab finalImg1 mein https nahi hoga
                                     console.log(`here it is 007=> ${finalImg1}`);
                                     updateVideoThumbnail(finalVideo1, finalImg1);

                                 }

                             }

                         }

                     }, 300);
                 }


             }
             setTimeout(window.trackActiveVideoSlideState, 100);
         }
     } else {

         setTimeout(() => {
             $('.product__media-item').each(function() {
                 console.log($(this).hasClass('video-playing-jt'));

                 if ($(this).hasClass('video-playing-jt')) {
                     $(this).addClass('here1236');

                     $(this).remove();
                 }
             });
         }, 1500);

     }


     //video unmute function
     function enableSound() {
         const iframe = document.querySelector('.main-iframe-jt');
         if (!iframe) return;

         iframe.contentWindow.postMessage(JSON.stringify({
             event: "command",
             func: "unMute",
             args: []
         }), "*");

         iframe.contentWindow.postMessage(JSON.stringify({
             event: "command",
             func: "setVolume",
             args: [100]
         }), "*");
     }

     document.addEventListener("click", enableSound, {
         once: true
     });




     // function formatVideoD(url) {
     //   if (!url) return '';

     //   if (url.includes('youtu.be/')) {
     //     const id = url.split('youtu.be/')[1].split('?')[0];
     //     return 'https://www.youtube.com/embed/' + id;
     //   }

     //   if (url.includes('watch?v=')) {
     //     const id = url.split('watch?v=')[1].split('&')[0];
     //     return 'https://www.youtube.com/embed/' + id;
     //   }

     //   if (url.includes('/shorts/')) {
     //     const id = url.split('/shorts/')[1].split('?')[0];
     //     return 'https://www.youtube.com/embed/' + id;
     //   }

     //   if (url.includes('vimeo.com/')) {
     //     const id = url.split('vimeo.com/')[1].split('?')[0];
     //     return 'https://player.vimeo.com/video/' + id;
     //   }

     //   return url;
     // }


     // function updateVideoThumbnail(finalVideo, finalImg) {
     //   const thumbItemContainer = document.querySelector('.product__thumbs-item[data-is-video="true"] .product__thumbs-inner');
     //   if (!thumbItemContainer) return;

     //   const existingImg = thumbItemContainer.querySelector('img');
     //   if (existingImg) existingImg.remove();

     //   let thumbSrc = finalImg || '';

     //   if (thumbSrc && !thumbSrc.startsWith('http')) {
     //     if (!thumbSrc.includes('files/')) {
     //       thumbSrc = `https://cdn.shopify.com/s/files/1/2220/7229/files/${thumbSrc}`;
     //     } else {
     //       thumbSrc = `https://cdn.shopify.com/s/files/1/2220/7229/${thumbSrc}`;
     //     }
     //   }

     //   if (!thumbSrc && finalVideo.includes('youtu')) {
     //     const videoId = finalVideo.split('/').pop();
     //     thumbSrc = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
     //   }

     //   if (!thumbSrc) {
     //     thumbSrc = 'https://cdn.shopify.com/s/files/1/2220/7229/files/video_1.png?v=1773914158';
     //   }

     //   const imgEl = document.createElement('img');
     //   imgEl.src = thumbSrc;
     //   imgEl.alt = 'Video thumbnail';
     //   imgEl.loading = 'lazy';

     //   thumbItemContainer.prepend(imgEl);
     // }




     // document.addEventListener('DOMContentLoaded', function() {

     //   //for show filter option in collection
     // const hideBtn = document.querySelector(".hide-filters");
     // const showBtn = document.querySelector(".show-filters");

     //   const filterContainer = document.getElementById("FacetFiltersContainer");

     //   if (hideBtn && filterContainer && showBtn) { 
     //     hideBtn.addEventListener("click", function () {
     //     filterContainer.style.display = "none";
     //     showBtn.classList.remove("hidden");    
     //   });
     //   }

     //   if(showBtn && filterContainer){
     //     showBtn.addEventListener("click", function () {
     //     filterContainer.style.display = "block";
     //     showBtn.classList.add("hidden");   
     //     });
     //   }
     // //for hide filter code end


     //    // Determine initial variant or fallback
     // let initialVariant = null;

     // if (window.initialVariantId && window.productVariants?.length) {
     //   initialVariant = window.productVariants.find(
     //     v => v.id == window.initialVariantId
     //   );
     // }

     // // fallback (just in case)
     // if (!initialVariant && window.productVariants?.length) {
     //   initialVariant = window.productVariants[0];
     // }
     //     console.log('Initial variant:', initialVariant);
     //   console.log('Has featured media?', initialVariant?.featured_media);


     //   updateGalleryByVariant(initialVariant);
     //   if (typeof updateSwiperByVariant === "function") {
     //     updateSwiperByVariant(initialVariant);
     //   }

     //   document.addEventListener('click', function(e) {
     //     const cover = e.target.closest('.main-slide-cover-jt');
     //     if (cover) {
     //       const wrapper = cover.closest('.custom-video-wrapper-jt');
     //       if (wrapper) {
     //         wrapper.classList.add('video-playing-jt');
     //         const iframe = wrapper.querySelector('.main-iframe-jt');
     //         if (iframe) {
     //           cover.style.setProperty('display', 'none', 'important');
     //           const playUrl = iframe.getAttribute('data-src');
     //           if (playUrl && iframe.src !== playUrl) {
     //             iframe.src = playUrl;
     //           }
     //         }
     //       }
     //     }
     //   });
     // });




     // function updateGalleryByVariant(variant) {

     //   if (!variant) {
     //   variant = { id: null, title: '' };
     // }
     // const isDefaultVariant =
     //   !window.productVariants ||
     //   window.productVariants.length <= 1;

     //   const key = '#color_' + (variant.title || '')
     //   .toLowerCase()
     //   .replace(/[\/]+/g, '-')    
     //   .replace(/\s+/g, '-')      
     //   .replace(/-+/g, '-')        
     //   .replace(/[^\w-]/g, '')    
     //   .trim();



     //   let firstVisibleIndex = -1;

     //   // 🔥 HIGH PRIORITY FIX: Safely retrieve correct mapping variant objects
     //   const variantData =
     //   Array.isArray(window.productVariants) && variant.id
     //     ? window.productVariants.find(v => v.id == variant.id)
     //     : null;

     //   // Sync priority mapping values
     //   const variantVideo = (variantData && (variantData.youtube_video || variantData.youtube_video_url_variants_)) ? (variantData.youtube_video || variantData.youtube_video_url_variants_) : '';
     //   const variantImg = variantData ? (variantData.cover_image || variantData.featured_image) : '';

     //   const productVideo = window.productGlobalVideo || window.productVideo || '';
     //   const finalVideo = variantVideo || productVideo;
     //   const productImg = window.productGlobalCover || window.productVideoImg || '';
     //   let setupImg = variantImg || productImg || '';

     //   // Handle Shopify native file objects gracefully
     //   if (setupImg && typeof setupImg === 'object') {
     //     setupImg = setupImg.url || setupImg.src || '';
     //   }

     //   // Convert raw meta value string -> Valid absolute CDN URL path
     //   if (setupImg && typeof setupImg === 'string' && !setupImg.startsWith('http')) {
     //     setupImg = setupImg.trim();
     //     if (setupImg.startsWith('files/')) {
     //       setupImg = `https://cdn.shopify.com/s/files/1/2220/7229/${setupImg}`;
     //     } else {
     //       setupImg = `https://cdn.shopify.com/s/files/1/2220/7229/files/${setupImg}`;
     //     }
     //   }

     //   const finalImg = setupImg || 'https://cdn.shopify.com/s/files/1/2220/7229/files/video_1.png?v=1773914158';


     // updateVideoThumbnail(finalVideo, finalImg);
     // // moveVideoThumbnail();
     //   // MAIN IMAGES

     //   document.querySelectorAll('.product__media-item').forEach((item, index) => {

     //   // ✅ FIX: stop everything if no variants
     //   if (isDefaultVariant) {
     //     item.style.display = '';

     //     if (firstVisibleIndex === -1) {
     //       firstVisibleIndex = index;
     //     }

     //     return; 
     //   }

     //   const alt = (item.dataset.variantAlt || '').toLowerCase();

     //   // if (alt.includes(key) || item.dataset.isVideo === "true") {
     //   if (alt === key || item.dataset.isVideo === "true") {
     //     item.style.display = '';

     //     if (firstVisibleIndex === -1) {
     //       firstVisibleIndex = index;
     //     }
     //   } else {
     //     item.style.display = 'none';
     //   }
     // });


     // //UPDATE SWIPER AFTER FILTERING
     // if (window.productSwiper) {
     //   window.productSwiper.update();
     //   window.productSwiper.slideTo(0);
     // }




     // //SHOW/HIDE THUMBNAILS
     // document.querySelectorAll('.product__thumbs-item').forEach((item) => {

     //   if (isDefaultVariant) {
     //     item.style.display = '';
     //     return; 
     //   }




     //   const alt = (item.dataset.variantAlt || '').toLowerCase();

     // //    console.log('KEY:', key);
     // // console.log('ALT:', alt);
     // // console.log('MATCH:', alt.includes(key));

     //   if (alt.includes(key)) {
     //     item.style.display = '';
     //   } 
     //   else if (item.dataset.isVideo === "true") {
     //     item.style.display = finalVideo ? '' : 'none';
     //   } 
     //   else {
     //     item.style.display = 'none';
     //   }
     // });



     // // FORCE VIDEO TO INDEX 2 - PERMANENT LAYOUT STABILITY
     // const gallery = document.querySelector('.product__media-list');
     // const videoItem = document.querySelector('.product__media-item[data-is-video="true"]');

     // if (gallery && videoItem) {
     //   const visibleItems = Array.from(gallery.querySelectorAll('.product__media-item'))
     //     .filter(item => item.style.display !== 'none' && !item.classList.contains('swiper-slide-duplicate'));

     //   if (visibleItems.length > 1) {
     //     console.log("visibleItems.length-->>>"+ visibleItems.length);
     //     gallery.insertBefore(videoItem, visibleItems[2]); 
     //   }
     // }



     // // FORCE VIDEO THUMBNAIL TO INDEX 2 - PERMANENT LAYOUT STABILITY
     // const videoThumb = document.querySelector('.product__thumbs-item[data-is-video="true"]');
     // if (videoThumb) {
     //   const thumbsWrapper = videoThumb.closest('.swiper-wrapper') || videoThumb.parentElement;
     //   console.log("videoThumb ---->", videoThumb);
     //   console.log("thumbsWrapper ---->", thumbsWrapper);
     //   if (thumbsWrapper) {
     //     const items = Array.from(
     //       thumbsWrapper.querySelectorAll('.product__thumbs-item:not(.swiper-slide-duplicate)')
     //     ).filter(item => item.style.display !== 'none');

     //     if (items.length > 2) {
     //       thumbsWrapper.insertBefore(videoThumb, items[2]); 
     //     }
     //   }
     // }




     //   // ==========================================
     //   // UPDATE VIDEO SOURCE (MAIN SLIDE)
     //   // ==========================================
     //   const videoContainer = document.querySelector('.product__media-item[data-is-video="true"] .product__media');

     //   if (videoContainer && finalVideo) {
     //     videoContainer.innerHTML = '';

     //     if (finalVideo.endsWith('.mp4') || finalVideo.includes('.mp4')) {
     //       const videoEl = document.createElement('video');
     //       videoEl.setAttribute('data-video-url', finalVideo);
     //       videoEl.setAttribute('controls', '');
     //       videoEl.setAttribute('autoplay', '');
     //       videoEl.setAttribute('muted', '');
     //       videoEl.setAttribute('loop', '');
     //       videoEl.setAttribute('playsinline', '');
     //       videoEl.style.cssText = 'position: absolute !important; top:0; left:0; width:100% !important; height:100% !important; z-index:10 !important;';
     //       if (finalImg && !finalImg.includes('video_1.png')) {
     //          videoEl.setAttribute('poster', finalImg); 
     //       }

     //       const sourceEl = document.createElement('source');
     //       sourceEl.src = finalVideo;
     //       sourceEl.type = 'video/mp4';

     //       videoEl.appendChild(sourceEl);
     //       videoContainer.appendChild(videoEl);
     //       videoEl.load();
     //       videoEl.play();

     //     } else {
     //       let finalYoutubeId = finalVideo;
     //       if (finalYoutubeId.includes("youtu.be")) {
     //         finalYoutubeId = finalYoutubeId.split("/").pop().split("?")[0];
     //       } else if (finalYoutubeId.includes("/watch?v=")) {
     //         finalYoutubeId = finalYoutubeId.split("/watch?v=")[1].split("&")[0];
     //       } else if (finalYoutubeId.includes("/shorts/")) {
     //         finalYoutubeId = finalYoutubeId.split("/shorts/")[1].split("?")[0].split("&")[0];
     //       }

     //       const videoWrapperJt = document.createElement('div');
     //       videoWrapperJt.className = 'custom-video-wrapper-jt';
     //       videoWrapperJt.style.cssText = 'position: relative !important; width:100% !important; height:100% !important; display:block !important;';

     //       const coverLayerJt = document.createElement('div');
     //       coverLayerJt.className = 'main-slide-cover-jt';
     //       coverLayerJt.style.cssText = 'position: absolute !important; top:0; left:0; width:100%; height:100%; z-index:99999 !important; cursor:pointer; display:block; background:#fff;';

     //       let imgSrc = finalImg;
     //       if (!imgSrc || imgSrc.includes('video_1.png')) {
     //         imgSrc = `https://img.youtube.com/vi/${finalYoutubeId}/hqdefault.jpg`;
     //       }

     //       coverLayerJt.innerHTML = `
     //         <img src="${imgSrc}" alt="Video Cover" style="width:100% !important; height:100% !important; object-fit:cover !important; display:block !important;">
     //         <div class="play-btn-overlay-jt" style="position: absolute !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; background: rgba(0,0,0,0.8) !important; width: 75px !important; height: 75px !important; border-radius: 50% !important; display: flex !important; align-items: center !important; justify-content: center !important; box-shadow: 0 4px 15px rgba(0,0,0,0.4) !important; z-index:100000 !important;">
     //           <svg viewBox="0 0 36 36" height="32px" width="32px" fill="#FFF">   
     //             <path d="M32.16,16.08,8.94,4.47A2.07,2.07,0,0,0,6,6.32V29.53a2.06,2.06,0,0,0,3,1.85L32.16,19.77a2.07,2.07,0,0,0,0-3.7Z"></path>
     //           </svg>
     //         </div>
     //       `;

     //       const iframeEl = document.createElement('iframe');
     //       iframeEl.className = 'main-iframe-jt';
     //       // Enabled Autoplay, loop and active playlist variables directly to secure background processing
     //       iframeEl.setAttribute('data-src', `https://www.youtube.com/embed/${finalYoutubeId}?autoplay=1&mute=1&loop=1&playlist=${finalYoutubeId}&enablejsapi=1&rel=0`);
     //       iframeEl.src = 'about:blank'; 
     //       iframeEl.setAttribute('loading', 'lazy');
     //       iframeEl.setAttribute('width', '100%');
     //       iframeEl.setAttribute('height', '100%');
     //       iframeEl.setAttribute('frameborder', '0');
     //       iframeEl.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
     //       iframeEl.setAttribute('allowfullscreen', '');
     //       iframeEl.style.cssText = 'position: absolute !important; top:0; left:0; width:100% !important; height:100% !important; z-index:10 !important; border:none !important; margin:0; padding:0;';

     //       coverLayerJt.onclick = function(e) {
     //         e.stopPropagation();
     //         videoWrapperJt.classList.add('video-playing-jt');
     //         coverLayerJt.style.setProperty('display', 'none', 'important');
     //         iframeEl.src = iframeEl.getAttribute('data-src');
     //       };

     //       videoWrapperJt.appendChild(coverLayerJt);
     //       videoWrapperJt.appendChild(iframeEl);
     //       videoContainer.appendChild(videoWrapperJt);
     //     }
     //   }




     // const mainSwiper = document
     //   .querySelector('.product__media-list')
     //   ?.closest('.swiper')
     //   ?.swiper;

     // if (mainSwiper) {
     //   mainSwiper.update();

     //   if (firstVisibleIndex !== -1) {
     //     mainSwiper.slideTo(firstVisibleIndex, 0, false);
     //   }
     // }

     // console.log("MainSwiper----->>"+ mainSwiper);


     const mainSwiper = document
         .querySelector('.product__media-list')
         ?.closest('.swiper')
         ?.swiper;

     const drawerOpen = document.querySelector('.quick-view[open], .drawer.is-open');

     if (drawerOpen) return; // ❌ STOP if drawer is open


     if (mainSwiper) {
         mainSwiper.update();

         const normalize = (str = '') => {
             return str
                 .toLowerCase()
                 .replace(/\bamp-\b/gi, '')
                 .replace(/&/g, '')
                 .replace(/-+/g, '-') // replace - and _ with spaces
                 .replace(/\s+/g, '')
                 .trim();
         };

         requestAnimationFrame(() => {
             const slides = [...mainSwiper.slides];

             //  find first VISIBLE slide matching variant
             console.log("KEY:", normalize(key));

             slides.forEach(slide => {
                 console.log(
                     "SLIDE:",
                     normalize(slide.dataset.variantAlt || '')
                 );
             });

             const targetSlide = slides.find(slide =>
                 normalize(slide.dataset.variantAlt) === normalize(key) &&
                 slide.style.display !== 'none' &&
                 !slide.classList.contains('swiper-slide-duplicate')
             );

             if (!targetSlide) {
                 console.log("❌ No matching slide for", key);
                 return;
             }

             const swiperIndex = slides.indexOf(targetSlide);

             console.log(" SWIPER INDEX --->", swiperIndex);

             if (swiperIndex >= 0) {
                 mainSwiper.slideTo(swiperIndex, 0, false);

                 //REQUIRED for display:none case
                 mainSwiper.setTranslate(-targetSlide.offsetLeft);
                 mainSwiper.updateProgress();
                 mainSwiper.updateActiveIndex();
                 mainSwiper.updateSlidesClasses();
             }
         });
     }




     const thumbSwiper = document.querySelector('.product__thumbs')?.swiper;

     if (thumbSwiper) {
         thumbSwiper.update();
     }


 }



 function syncThumbsWithMainSlider() {
     const mediaGallery = document.querySelector('media-gallery');

     if (!mediaGallery || !mediaGallery.sliderInstance) {
         // wait until swiper is ready
         setTimeout(syncThumbsWithMainSlider, 200);
         return;
     }

     const swiper = mediaGallery.sliderInstance.slider;
     if (!swiper) return;


     swiper.on('slideChange', function() {

         const activeIndex = swiper.activeIndex;

         const thumbs = Array.from(document.querySelectorAll('.product__thumbs-item'))
             .filter(t => t.style.display !== 'none');

         const activeThumb = thumbs[activeIndex];
         if (!activeThumb) return;

         thumbs.forEach(t => t.classList.remove('is-active'));
         activeThumb.classList.add('is-active');

         // keep centered
         activeThumb.scrollIntoView({
             behavior: 'smooth',
             block: 'center'
         });
     });
 }




 document.addEventListener('click', function(e) {

     const thumb = e.target.closest('.product__thumbs-item');
     if (!thumb) return;

     const swiper = document.querySelector('media-gallery')?.sliderInstance?.slider;
     if (!swiper) return;

     const thumbs = Array.from(document.querySelectorAll('.product__thumbs-item'))
         .filter(t => t.style.display !== 'none');

     const index = thumbs.indexOf(thumb);

     if (index >= 0) {
         swiper.slideTo(index, 300);

         thumbs.forEach(t => t.classList.remove('is-active'));
         thumb.classList.add('is-active');

         // keep thumb in view
         thumb.scrollIntoView({
             behavior: 'smooth',
             block: 'center'
         });
     }
 });




 function scrollToFirstVisibleThumb() {
     const thumbs = Array.from(document.querySelectorAll('.product__thumbs-item'))
         .filter(t => t.style.display !== 'none');

     if (!thumbs.length) return;

     const firstThumb = thumbs[0];

     // mark active
     thumbs.forEach(t => t.classList.remove('is-active'));
     firstThumb.classList.add('is-active');

     // scroll into view (centered)
     firstThumb.scrollIntoView({
         behavior: 'auto',
         block: 'center'
     });
 }


 window.addEventListener('load', syncThumbsWithMainSlider);

 // run on load
 window.addEventListener('load', scrollToFirstVisibleThumb);




 function filterDrawerImagesByVariant(variant, drawer) {
     if (!variant || !drawer) return;

     const allMedia = drawer.querySelectorAll('.product__media-item');
     const allThumbs = drawer.querySelectorAll('.product__thumbs-item');

     allMedia.forEach(item => item.style.display = '');
     allThumbs.forEach(item => item.style.display = '');


     // const key = (variant.title || '').toLowerCase().split(' ')[0];
     const key = '#color_' + (variant.title || '')
         .toLowerCase()
         .replace(/[\/]+/g, '-')
         .replace(/\s+/g, '-')
         .replace(/-+/g, '-')
         .replace(/[^\w-]/g, '')
         .replace(/\bamp-\b/gi, '')
         .replace(/&/g, '')
         .replace(/-+/g, '-')
         .trim();


     const mediaItems = drawer.querySelectorAll('.product__media-item');
     const thumbItems = drawer.querySelectorAll('.product__thumbs-item');

     let visibleCount = 0;
     let firstVisibleIndex = -1;

     mediaItems.forEach((item, index) => {
         // const img = item.querySelector('img');
         // const alt = (img?.getAttribute('alt') || '').toLowerCase();
         const alt = (item.dataset.variantAlt || '').toLowerCase();


         if (alt.includes(key)) {
             item.style.display = '';
             visibleCount++;

             if (firstVisibleIndex === -1) {
                 firstVisibleIndex = index;
             }
         } else {
             item.style.display = 'none';
         }
     });

     thumbItems.forEach(item => {
         // const img = item.querySelector('img');
         // const alt = (img?.getAttribute('alt') || '').toLowerCase();
         const alt = (item.dataset.variantAlt || '').toLowerCase();


         if (alt.includes(key)) {
             item.style.display = '';
         } else {
             item.style.display = 'none';
         }
     });

     // if (visibleCount <= 1) {
     if (visibleCount === 0) {
         mediaItems.forEach(item => item.style.display = '');
         thumbItems.forEach(item => item.style.display = '');
         firstVisibleIndex = 0;
     }

     mediaItems.forEach(item => {
         const iframe = item.querySelector('iframe[data-video-url]');
         if (iframe && item.style.display !== 'none' && !iframe.src) {
             iframe.src = formatVideoD(iframe.dataset.videoUrl);
         }
     });


     const swiper = drawer.querySelector('.product__media-list')?.swiper;
     if (swiper && firstVisibleIndex !== -1) {
         swiper.update();

         requestAnimationFrame(() => {
             swiper.slideTo(firstVisibleIndex, 0);
         });
     }

 }




 document.addEventListener('click', function(e) {

     const btn = e.target.closest(
         '.product-card__action-button, .product-card__quickview'
     );
     if (!btn) return;

     const modalId = btn.getAttribute('aria-controls');
     const drawer = document.getElementById(modalId);
     if (!drawer) return;

     let attempts = 0;


     const interval = setInterval(() => {

         const script = drawer.querySelector('script[data-selected-variant]');
         const mediaItems = drawer.querySelectorAll('.product__media-item');

         if (!script || mediaItems.length === 0) return;

         const variant = JSON.parse(script.textContent);

         filterDrawerImagesByVariant(variant, drawer);

         clearInterval(interval);

         attempts++;
         if (attempts > 20) clearInterval(interval);

     }, 80);

 });




 document.addEventListener('variant:changed', function(event) {
     const variant = event.detail?.variant;

     const drawer = document.querySelector('.quick-view[open], .drawer.is-open');
     if (!drawer) return;

     filterDrawerImagesByVariant(variant, drawer);
 });




 //custom grid variant
 document.addEventListener('click', function(e) {
     const item = e.target.closest('.swatch-value');
     if (!item) return;

     const value = item.dataset.vTitle;

     const select = document.querySelector('select[name="options[Color]"]');

     if (select) {
         select.value = value;
         select.dispatchEvent(new Event('change', {
             bubbles: true
         }));
     }
 });
 //end